module.exports = __webpack_public_path__ + "media/images/company_placeholder-61dc3aea161bb88bf6cc8459757fbd7c.png";